module.exports = __webpack_public_path__ + "static/media/it.31f8ead7.pdf";